import React from 'react';
import { Button, Modal } from '../../../../Components/uielements';
import {
  TwoColumns,
  ModalButtonWrapper,
  ModalWrapper,
} from '../../../../services/settings/appStyle/global.style';
import { ModalLabel } from '../../UserV2/user.style';
import { IntlMessages } from '../../../../helper/langHelper';

const ViewCompanyDetailsModal = ({ onClose, data }) => {
  return (
    <>
      <Modal
        isOpen={true}
        onClose={onClose}
        title={<IntlMessages id="company.module.company.details" />}
      >
        <ModalWrapper>
          <>
            <TwoColumns>
              <ModalLabel>
                <IntlMessages id="table.col.name" /> :
              </ModalLabel>
              <ModalLabel isCapitalize={true}>{data?.name}</ModalLabel>
            </TwoColumns>
            <TwoColumns>
              <ModalLabel>
                <IntlMessages id="label.town" /> :
              </ModalLabel>
              <ModalLabel>
                {data?.addressTown ?? <IntlMessages id="label.not.provided" />}
              </ModalLabel>
            </TwoColumns>
            <TwoColumns>
              <ModalLabel>
                <IntlMessages id="label.state" /> :
              </ModalLabel>
              <ModalLabel>
                {data?.addressState ?? <IntlMessages id="label.not.provided" />}
              </ModalLabel>
            </TwoColumns>
            <TwoColumns>
              <ModalLabel>
                <IntlMessages id="label.street" /> :
              </ModalLabel>
              <ModalLabel>{data?.addressStreet}</ModalLabel>
            </TwoColumns>
            <TwoColumns>
              <ModalLabel>
                <IntlMessages id="table.col.subscription.plan" />:
              </ModalLabel>
              <ModalLabel>{data?.plan ?? 'VISITOR'}</ModalLabel>
            </TwoColumns>
          </>
          <ModalButtonWrapper>
            <Button onClick={onClose}>
              <IntlMessages id="modal.button.close" />
            </Button>
          </ModalButtonWrapper>
        </ModalWrapper>
      </Modal>
    </>
  );
};

export default ViewCompanyDetailsModal;
